import { render, staticRenderFns } from "./GuideEditor.vue?vue&type=template&id=6044981d&scoped=true&"
import script from "./GuideEditor.vue?vue&type=script&lang=js&"
export * from "./GuideEditor.vue?vue&type=script&lang=js&"
import style0 from "./GuideEditor.vue?vue&type=style&index=0&id=6044981d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044981d",
  null
  
)

export default component.exports